import { ApplicationConfig, inject, provideAppInitializer, provideZonelessChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import * as Rx from 'rxjs';
import { tap } from 'rxjs/operators';
import { HttpClient, HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { OVERLAY_DEFAULT_CONFIG, OverlayDefaultConfig } from '@angular/cdk/overlay';
import { MatDialogRef } from '@angular/material/dialog';
import * as AppSrv from "./app.service";
import { GooglAnalyticsService } from './googleAnalyticsService';
import { GoogleAPIService } from './google/google.service';
import { UserInfoService } from './user/user-info.service';
import { RoleService } from './role/role.service';
import { MonitorHTTP } from './auth.monitor';
import { SocialObjectAPIService } from './socialObject/social-object.service';
import { AccountAPIService } from './user/account-api.service';
import { JourneyRoutes } from './app.routes';

export const AppConfig: ApplicationConfig = {
	providers: [
		AppSrv.AppSettingService,
		AppSrv.AppUtilityService,
		UserInfoService,
		provideAppInitializer(() => {
			const googleAnalyticsService = inject(GooglAnalyticsService);
			const googleApi = inject(GoogleAPIService);
			return Rx.firstValueFrom(
				inject(HttpClient).get<any>(AppSrv.AppSettingService.appConfig.JourneyAPIUrl + "Config/JourneysMap")
					.pipe(tap((config: AppSrv.IAppConfig) => {
						AppSrv.AppSettingService.appConfig = config;
						//load google analytics script after config is loaded
						googleAnalyticsService.init(config.GoogleAnalyticsMeasurementId);
						googleApi.loadScripts();
					}))
			).catch(() => {
				AppSrv.AppSettingService.appConfig = null;
				alert("Fail to load configuration, please reload this page");
				return;
			});
		}),
		provideAppInitializer(() => {
			inject(AppSrv.AppService).checkAccountCookie();
		}),
		provideAppInitializer(async () => {
			await inject(AccountAPIService).initMyProfile();
		}),
		provideAppInitializer(async () => {
			await inject(SocialObjectAPIService).initUserSocialObjects();
		}),
		provideAppInitializer(async () => {
			try { await inject(RoleService).initRoles(); } catch (err) { console.log(err); }
		}),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: MonitorHTTP,
			multi: true
		},
		{
			provide: MatDialogRef,
			useValue: {}
		},
		{
			// Prevents top-layer rendering (HTML popover), without material dialog will render on very top regardless swal or any other popover, causing UI/UX issue
			provide: OVERLAY_DEFAULT_CONFIG,
			useValue: { usePopover: false, } as OverlayDefaultConfig,
		},
		provideHttpClient(withInterceptorsFromDi()),
		provideZonelessChangeDetection(),
		provideRouter(JourneyRoutes)
	]
};
